import { useQuery } from '@tanstack/react-query';
import { useOrganization } from '@/contexts/OrganizationContext';
import { campaignRepository } from '../repositories/campaign.repository';
import { campaignKeys } from '../services/campaign.keys';
import type { Campaign } from '../types/campaign.types';

export function useCampaigns() {
  const { currentOrganization } = useOrganization();
  const fallbackBrandName =
    currentOrganization?.organization_type === 'brand' ? currentOrganization?.name : undefined;

  return useQuery<Campaign[]>({
    queryKey: [...campaignKeys.all, currentOrganization?.id],
    queryFn: async () => {
      return campaignRepository.getAll(currentOrganization?.id, fallbackBrandName);
    },
    staleTime: 1000 * 60 * 2,
    gcTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });
}
